export const ALLOWED_ADMINS = ['m.0543125382@gmail.com'];
